import * as FS from '@fullstory/browser';
import { PluginObject, VueConstructor } from 'vue';

type fullStoryOptions = { orgId: string };

const FullStoryPlugin: PluginObject<fullStoryOptions> = {
  install: (Vue: VueConstructor, options?: fullStoryOptions) => {
    FS.init({ orgId: options?.orgId || '' });
    /* eslint-disable no-multi-assign */
    Vue.fullStory = Vue.prototype.$fullStory = FS;
  },
};

export default FullStoryPlugin;
